// Hides the floating WhatsApp button while a [data-whatsapp-avoid] element (the product form) reaches the bottom of the viewport.
class SWhatsappFloat extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;
    const targets = this.ownerDocument.querySelectorAll('[data-whatsapp-avoid]');
    if (targets.length === 0) return;

    const visibleTargets = new Set();
    // Only the bottom 22% of the viewport counts, which is where the button sits.
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visibleTargets.add(entry.target);
          } else {
            visibleTargets.delete(entry.target);
          }
        }
        this.toggleAttribute('data-hidden', visibleTargets.size > 0);
      },
      { rootMargin: '-78% 0px 0px 0px' }
    );
    for (const target of targets) this.observer.observe(target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-whatsapp-float')) {
  customElements.define('s-whatsapp-float', SWhatsappFloat);
}
